import { render, staticRenderFns } from "./AttachedFilesModal.vue?vue&type=template&id=dcca23ce&"
import script from "./AttachedFilesModal.vue?vue&type=script&lang=js&"
export * from "./AttachedFilesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports